export class DevelopmentTask {
  id: string;
  name: string;
  timeEstimatedEmployee: number;
  timeConsumedEmployee: number;
  workOrderId: string;
  comment: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(task) {
    this.id = task.developmentTaskId || undefined;
    this.name = task.name || undefined;
    this.timeEstimatedEmployee = task.timeEstimatedEmployee || 0;
    this.timeConsumedEmployee = task.timeConsumedEmployee || 0;
    this.workOrderId = task.workOrderId || undefined;
    this.comment = task.comment || undefined;
    this.createdAt = task.createdAt || undefined;
    this.updatedAt = task.updatedAt || undefined;
  }
}